const goTopFunction = () => {
	const toTop = document.querySelector('#go-top-btn')

	toTop.addEventListener('click', () => {
		document.body.scrollTop = 0; // Safari
		document.documentElement.scrollTop = 0;
	})
}

export { goTopFunction }